import i18n from '@/i18n/i18n';

export default [
    {
        path: '/notifications/expense',
        name: 'notifications-expense',
        component: () => import('@/views/app/notifications/pages/expenses/Index.vue'),
        meta: {
            authRequired: true,
            rule: 'editor',
            can: ['IU MAIL APPROVED EXPENSES VIEW'],
            breadcrumb: [
                { title: 'Home', url: '/' },
                { title: i18n.messages[i18n.locale].notifications, url: '/notifications/expense'},
                { title: i18n.messages[i18n.locale].expenses, url: '/notifications/expense', active: true },
            ]
        }
    },
]
